<aw-search-input
  [variant]="'filled'"
  [minLength]="1"
  [autofocus]="false"
  [placeholder]="placeholder()"
  [currentValue]="currentValue()"
  (onSearch)="searchChanged.emit($event)"
  (click)="haptics.buttonClick()"
/>
